import { displayErrorList } from '../../shared/error/errorManager';
import {toastr} from 'react-redux-toastr';
import moment from 'moment';
import {
  initialize,
  reset,
  change,
  arrayRemoveAll,
  arrayInsert,
  formValueSelector
} from 'redux-form';
import {
  postJsonAsync,
  getJsonAsync,
  putJsonAsync,
  navigateTo,
  deleteJsonAsync,
  handlePrint
} from 'shared/actions';
import {
  rostersHasUserIdModifications
} from 'shared/actionRosterPosition';
import {
  displaySquadChangeModal,
  setPaymentLogHistory,
  setCaptRosterWarnings,
  displayEventChangeModal
} from './actionTypes';
import {
  retrieveEntries,
  retrieveUserVirtualEntries,
  hasPendingRosterChanges
} from '../shared/actions';
import {
  assignChildTeamOwnedVirtualEntry,
  assignTeamOwnedVirtualEntry,
  calculateBalanceDue,
  cancelEntryDetails,
  cancelEntryPaymentLogHistory,
  cancelPurchasedEntryForm,
  closeVirtualEntryEditing,
  cancelVirtualEventPaymentLogHistory,
  clearRosterPosition,
  displayPaymentLogHistory,
  displayVirtualEventPaymentLog,
  moveRosterDown,
  moveRosterUp,
  resetTeamOwnedVirtualEntryEventAssignment,
  searchingFinished,
  searchingStarts,
  setEntrySelectedEntry,
  setEntryStateDisabled,
  setIsProfessional,
  setMemberSearchField,
  setRosterConfirmationVisibility,
  updateRosterInfo,
  setCartRosterOnEditingEntry,
  setCartRosterOnCartVirtualEntries
} from '../shared/actionTypes';
import * as actions from './actions';

import {
  setRostersComplete
} from '../rostercheckout/actionTypes';

const scrollToFirstHighlightedEntry = () => {
  const elementToScroll = document.querySelectorAll('.list-group-item-labeled.highlight');

  if(elementToScroll && elementToScroll.length) {
    setTimeout(() => {
      elementToScroll[0].scrollIntoView();
    }, 900); // execute scrolling after a period of time to allow rendering to execute other prior animations
  }
};

export const handleRosterConfirmationCancel = () => (dispatch, getState) => {
  const state = getState();
  const {
    rosterConfirmationNextAction,
    rosterConfirmationNextActionArgs
  } = state.registration.manage;

  dispatch(reset('entryForm'));
  dispatch(cancelPurchasedEntryForm());
  dispatch(setRosterConfirmationVisibility(false));
  dispatch(resetTeamOwnedVirtualEntryEventAssignment());
  dispatch(retrieveUserVirtualEntries(state.registration.base.tournamentId));
  if (rosterConfirmationNextAction && rosterConfirmationNextActionArgs)
    dispatch(actions[rosterConfirmationNextAction](rosterConfirmationNextActionArgs)); // eslint-disable-line import/namespace
  scrollToFirstHighlightedEntry();
};

export const handleIsProfessionalChange = (position, value) => dispatch => {
  dispatch(setIsProfessional(position, value));
  dispatch(change('entryForm', `isProfessional-${position}`, value));
};

export const handlePayBalanceClick = () => (dispatch, getState) => {
  // prevent user to loose changes while editing an entry
  if(dispatch(hasPendingRosterChanges(handlePayBalanceClick.name))) { return; }

  const state = getState(),
    tournamentId = state.registration.base.tournamentId,
    tournamentStripeKey = state.registration.base.tournamentStripeKey,
    entries = state.registration.shared.entries
      .filter(entry => entry.selected)
      .map(entry => entry.id),
    virtualEvents = state.registration.shared.virtualEntries
      .filter(virtualEvent => virtualEvent.selected)
      .map(virtualEvent => virtualEvent.virtualEventId),
    teamOwnedVirtualEvents = state.registration.shared.teamOwnedVirtualEntriesAvailable
      .filter(teamOwnedVirtualEntries => teamOwnedVirtualEntries.selected)
      .map(teamOwnedVirtualEvent => teamOwnedVirtualEvent.virtualEventId);

  const body = {
    tournamentId,
    entries,
    virtualEvents,
    teamOwnedVirtualEvents,
    source: 'captainBalance'
  };

  dispatch(postJsonAsync(`registration/payment/createSession`, body))
  .then(response => {
    const publishableKey = tournamentStripeKey;
    const stripe = window.Stripe(publishableKey);
    const sessionId = response.paymentId;

    stripe.redirectToCheckout({
      sessionId
    });
  });
};

export const handleCompletePayBalance = (tournamentId, paymentData) => dispatch => {
  dispatch(postJsonAsync('registration/payment/balance', {
    BypassWebHooks: paymentData.BypassWebHooks,
    PaymentId: paymentData.PaymentId
  }))
  .then(response => {
    if (response) toastr.success('Payment Processed!', 'Selected entries were paid successfully.');
    dispatch(retrieveEntries(tournamentId));
    dispatch(retrieveUserVirtualEntries(tournamentId));
  });

  if (localStorage.bypassWebHooks)
    delete localStorage.bypassWebHooks;
};

export const handleVirtualEntryPaymentLogClick = virtualEventId => dispatch => {
  // prevent user to loose changes while editing an entry
  if(dispatch(hasPendingRosterChanges(handleVirtualEntryPaymentLogClick.name, virtualEventId))) { return; }

  dispatch(getJsonAsync(`registration/virtualevent/${virtualEventId}/payment/log`))
  .then(paymentLog => {
    // close other panels
    dispatch(cancelEntryDetails());
    dispatch(cancelPurchasedEntryForm());
    dispatch(closeVirtualEntryEditing());
    dispatch(cancelEntryPaymentLogHistory());
    dispatch(setPaymentLogHistory(paymentLog));
    dispatch(displayVirtualEventPaymentLog(virtualEventId));
  });
};

export const handlePaymentLogSelection = entryId => dispatch => {
  // prevent user to loose changes while editing an entry
  if(dispatch(hasPendingRosterChanges(handlePaymentLogSelection.name, entryId))) { return; }

  dispatch(getJsonAsync(`registration/entry/${entryId}/payment/log`))
  .then(paymentLog => {
    // close other panels
    dispatch(cancelEntryDetails());
    dispatch(cancelPurchasedEntryForm());
    dispatch(closeVirtualEntryEditing());
    dispatch(cancelVirtualEventPaymentLogHistory());
    dispatch(setPaymentLogHistory(paymentLog));
    dispatch(displayPaymentLogHistory(entryId));
  });
};

export const changePurchasedEntryFormField = (field, value) => {
  change('entryForm', field, value);
};

export const handleCountryChange = value => (dispatch, getState) => {
  const countries = getState().registration.shared.countries,
    selectedCountry = countries.find(x => x.value === value),
    entryId = getState().form.entryForm.values.id,
    disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';

  dispatch(setEntryStateDisabled(entryId, disableEntryState));
  if(disableEntryState) {
    dispatch(change('entryForm', 'state', null));
  }
};

export const validate = (data) => {
  const errors = {};

  if (!data.name) {
    errors.name = 'We need to be able to identify your team.';
  }
  return errors;
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const { base, shared } = getState().registration;
  // Make sure we don't save if there are modifications in the user ID 
  let rosterPositions = shared.rosterPositions;
  let hasRosterPositionChanged = rostersHasUserIdModifications(rosterPositions);

  if (hasRosterPositionChanged) {
    resolve();
    return;
  }

  const editingEntry = shared.entries.find(x => x.editing);
  const persistedParents = shared.parentTeamOwnedVirtualEntries
    .filter(x => x.id.length === 36);
  const persistedChildren = shared.childTeamOwnedVirtualEntries
    .filter(x => x.id.length === 36);
  const virtualEntries = persistedParents.concat(persistedChildren);
  const assignedCartParents = shared.parentTeamOwnedVirtualEntries
    .filter(x => x.id.length !== 36 && x.teamEntryId === editingEntry.id);
  const assignedCartChildren = shared.childTeamOwnedVirtualEntries
    .filter(x => x.id.length !== 36 && x.teamEntryId === editingEntry.id);
  const cartRosterIds = shared.parentTeamOwnedVirtualEntries
    .filter(x => x.id.length !== 36 && x.teamEntryId == null && x.cartRosterId !== undefined)
    .map(x => x.cartRosterId)
    .concat(shared.childTeamOwnedVirtualEntries
      .filter(x => x.id.length !== 36 && x.teamEntryId == null && x.cartRosterId !== undefined)
      .map(x => x.cartRosterId));

  dispatch(putJsonAsync(`registration/entry/${data.id}`,
      {
        rosterPositions: rosterPositions,
        name: data.name,
        state: data.state,
        countryId: data.countryId,
        pairCode: data.pairCode,
        groupCode: data.groupCode
      }, false))
    .then(() => {
      dispatch(putJsonAsync('virtualevent/teams',
          {
            virtualEntries
          }))
        .then(() => {
          cartRosterIds.forEach(cartRoster => {
            dispatch(deleteJsonAsync(`registration/cartroster`,
              {
                id: cartRoster
              }));
          });
          if (assignedCartParents.length > 0 || assignedCartChildren.length > 0) {
            const assignedVirtualEntries = assignedCartParents
              .map(item => ({ virtualEventId: item.virtualEventId, teamEntryId: item.teamEntryId, id: item.id }))
              .concat(assignedCartChildren.map(item => ({
                virtualEventId: item.virtualEventId,
                teamEntryId: item.teamEntryId,
                id: item.id
              })));
            const rosterData = {
              virtualEntries: assignedVirtualEntries
            };

            dispatch(postJsonAsync(`registration/cartroster`,
                {
                  id: null,
                  tournamentId: base.tournamentId,
                  rosterType: "Virtual Entry",
                  rosterData: JSON.stringify(rosterData)
                }))
              .then((response) => {
                const cartRosterId = response.id;

                dispatch(setCartRosterOnEditingEntry(cartRosterId));
                dispatch(setCartRosterOnCartVirtualEntries(assignedVirtualEntries, cartRosterId));
              });
          }

          dispatch(setRosterConfirmationVisibility(false));
          toastr.success('Saved!', 'Entry information successfully saved.');
          dispatch(retrieveEntries(base.tournamentId))
            .then(() => {
              if (shared.rosterConfirmationNextAction && shared.rosterConfirmationNextActionArgs) {
                dispatch(actions[shared.rosterConfirmationNextAction](shared.rosterConfirmationNextActionArgs)); // eslint-disable-line import/namespace
                scrollToFirstHighlightedEntry();
              }
              dispatch(checkForCompleteRosters());
            });
          resolve();
        });
    })
    .catch(error => {
      dispatch(setRosterConfirmationVisibility(false));

      if(!Array.isArray(error))
      {
        error = [ error.message ];
      }
  
      dispatch(displayErrorList(error));

      resolve();
    });
});

export const handleMoveDownClick = index => (dispatch) => {
  dispatch(moveRosterDown(index));
  dispatch(moveUp(index));
};

export const handleMoveUpClick = index => (dispatch) => { 
  dispatch(moveRosterUp(index)); 
  dispatch(moveUp(index - 1));
};

const moveUp = index => (dispatch, getState) => {
  const formValues = getState().form.entryForm.values;

  let average1 = formValues[`average-${index + 1}`];
  let average2 = formValues[`average-${index + 2}`];

  if (!average1) average1 = '';
  if (!average2) average2 = ''; 

  // swap averages in form data because of redux-form is handling those fields
  dispatch(change('entryForm', `average-${index + 1}`, average2));
  dispatch(change('entryForm', `average-${index + 2}`, average1));
  dispatch(change('entryForm', `usbcId-${index + 1}`, formValues[`usbcId-${index + 2}`]));
  dispatch(change('entryForm', `usbcId-${index + 2}`, formValues[`usbcId-${index + 1}`]));
  dispatch(change('entryForm', `isProfessional-${index + 1}`, formValues[`isProfessional-${index + 2}`]));
  dispatch(change('entryForm', `isProfessional-${index + 2}`, formValues[`isProfessional-${index + 1}`]));
  dispatch(autoSetTeamNameForRosterFromState());
};

export const handleSearchEnterKeyPress = (roster, event) => dispatch => {
  if(event.keyCode === 13) {
    event.preventDefault();
    event.stopPropagation();
    dispatch(handleSearch(roster));
  }
};

export const handleSearchChange = (roster, event) => dispatch => {
  roster._searchValue = event.target.value.trim();
  dispatch(setMemberSearchField(roster));
};

export const handleSearch = rosterPosition => (dispatch, getState) => {
  const state = getState();
  const tournamentId = state.registration.base.tournamentId;
  let entry = state.registration.shared.entries.find(x => x.editing);
  
  // do nothing if usbc search field is empty
  if (!rosterPosition._searchValue) {
    return false;
  } 

  if (!entry) {
    entry = state.registration.shared.cartEntries.find(x => x.editing);
  }
  const eventId = entry && entry.eventId ? entry.eventId : null;
  const squadId = entry.squadId;

  // UC33 Add Item to Cart
  dispatch(searchingStarts(rosterPosition));
  dispatch(getJsonAsync(`registration/entry/${tournamentId}/member/${rosterPosition._searchValue}/event/${eventId}/squad/${squadId}`))
  .then(bowler => {
    const updatedRosterPosition = {
        ...rosterPosition,
        bowler: bowler.error ? {} : bowler,
        usbcId: rosterPosition._searchValue,
        _errorMessage: bowler.error ? bowler.error.Message : null
      };

    dispatch(updateRosterInfo(updatedRosterPosition));
    dispatch(setRosterPositionAverage(updatedRosterPosition));
    dispatch(autoSetTeamNameForRosterFromState());
    dispatch(retrieveRosterWarnings());
    
    // set information in redux-form state to track changes
    dispatch(change('entryForm', `average-${rosterPosition.position}`, bowler.average));
    dispatch(change('entryForm', `usbcId-${rosterPosition.position}`, bowler.usbcId));
    dispatch(change('entryForm', `isProfessional-${rosterPosition.position}`, bowler.isProfessional));
  })
  .finally(() => 
  { 
    dispatch(searchingFinished());
  });
};

export const setRosterPositionAverage = rosterPosition => dispatch =>
  dispatch(change('entryForm', `average-${rosterPosition.position}`, rosterPosition.bowler.average));

export const autoSetTeamNameForRosterFromState = () => (dispatch, getState) => {
  const state = getState(),
    rosterPositions = state.registration.shared.rosterPositions,
    rosterPositionsQty = rosterPositions.length;

  // singles
  if(rosterPositionsQty === 1) {
    dispatch(change('entryForm', `name`, `${rosterPositions[0].bowler.firstName} ${rosterPositions[0].bowler.lastName}`));

  // doubles
  } else if(rosterPositionsQty === 2) {
    const teamNameA = rosterPositions[0].bowler && rosterPositions[0].bowler.lastName
      ? rosterPositions[0].bowler.lastName
      : '';
    const teamNameB = rosterPositions[1].bowler && rosterPositions[1].bowler.lastName
      ? rosterPositions[1].bowler.lastName
      : '';

    if(teamNameA || teamNameB) {
      dispatch(change('entryForm', `name`, `${teamNameA}${teamNameA && teamNameB ? '/': ''}${teamNameB}`));
    } else {
      dispatch(change('entryForm', `name`, 'No Team Name'));
    }
  }
};

export const handleRosterPositionCleared = index => dispatch => {
  dispatch(clearRosterPosition(index));
  dispatch(change('entryForm', `average-${index + 1}`, ""));
  dispatch(change('entryForm', `usbcId-${index + 1}`, null));
  dispatch(change('entryForm', `isProfessional-${index + 1}`, false));
  dispatch(autoSetTeamNameForRosterFromState());
  dispatch(retrieveRosterWarnings());
};

export const handleEntrySelectChecked = entryId => dispatch => {
  dispatch(setEntrySelectedEntry(entryId));
  dispatch(calculateBalanceDue());
};

export const handlePurchaseClick = () => (dispatch, getState) => {
  // prevent user from losing changes while editing an entry
  if(dispatch(hasPendingRosterChanges(handlePurchaseClick.name))) { return; }

  const tournamentId = getState().registration.base.tournamentId;

  dispatch(navigateTo(`registration/schedule/${tournamentId}`));
};

export const validateCaptainManageSquadChangeForm = data => {
  let errors = {};
  let childSquadsAvailable = [];
  let childSquads = [];

  if (!data.parentSquadId) {
    errors.parentSquadId = 'Squad time is required';
  }

  if(data.childrenEntries && data.childrenEntries.length) {
    errors.childrenEntries = [];
    childSquadsAvailable = data.childAvailableSquads.slice();
    childSquads = data.childrenEntries.map(x => x.squadId).slice();
    data.childrenEntries.forEach((value, index) => {
      if(!value.squadId) {
        errors.childrenEntries[index] = {};
        errors.childrenEntries[index].squadId = 'Squad time is required';
        return;
      }
      
      let currentSquad = childSquadsAvailable.find(x => x.value == value.squadId);
      let existingSquads = childSquads.filter(x => x == value.squadId);
      
      if(currentSquad && (currentSquad.quantity == 0 || currentSquad.quantity < existingSquads.length)){
        errors.childrenEntries[index] = {};
        errors.childrenEntries[index].squadId = 'There are not enough available slots to move all the Doubles/Singles to the squad requested. Please select another squad for your Doubles/Singles';
      }
    });
  }

  return errors;
};

export const handleSquadChangeCancel = () => dispatch => {
  dispatch(displaySquadChangeModal(false));
};

export const handleSquadChangeSave = formData => (dispatch, getState) => new Promise(resolve => {
  const payload = {
    entryId: formData.entryId,
    squadId: formData.parentSquadId,
    childrenEntries: formData.childrenEntries
  };

  dispatch(putJsonAsync(`registration/entry/${formData.entryId}/squad/change`, payload))
  .then(() => {
    const tournamentId = getState().registration.base.tournamentId;

    dispatch(retrieveEntries(tournamentId));
    dispatch(displaySquadChangeModal(false));
    toastr.success('Squad Changed!', 'The squad was changed successfully.');
    resolve();
  })
  .catch(() => {
    dispatch(displaySquadChangeModal(false));
    toastr.error('Squad Not Updated!', 'There was an error changing squad for the entry.');
    resolve();
  });
});

export const handleSquadDateChanged = (entryId, date) => dispatch => new Promise(resolve => {
  dispatch(change('captainManageSquadChangeForm', 'currentSquadDate', date));
  dispatch(getAvailableSquadsForDate(entryId, date, null, true))
  .then(response => resolve(response));
});

export const handleSquadTimeChanged = (entryId, parentSquadId) => (dispatch, getState) => new Promise(resolve => {
  const selector = formValueSelector('captainManageSquadChangeForm');
  const date = selector(getState(), 'parentSquadDateTime');    
  dispatch(getAvailableSquadsForDate(entryId, date, parentSquadId, true))
  .then(response => resolve(response));
});

const getAvailableSquadsForDate = (entryId, squadDate, parentSquadId, resetChildren = false) => dispatch => new Promise(resolve => {
  if(!squadDate) { return; } // don't do anything if the date is empty

  const formattedDate = moment.parseZone(squadDate).format(`YYYY-MM-DD`);
  const now = Date();

  dispatch(getJsonAsync(`registration/entry/${entryId}/squads/${formattedDate}/id/${parentSquadId}`))
  .then(response => {
    const parentAvailableSquads = response.parentAvailableSquads.map(x => ({value: x.id, label: x.description})),
      childAvailableSquads = response.childAvailableSquads.map(x => ({value: x.id, label: x.description, quantity: x.quantity}));

    dispatch(change('captainManageSquadChangeForm', 'childSquadDateTime', response.childSquadDateTime));
    dispatch(change('captainManageSquadChangeForm', 'childEventName', response.childEventName));
    dispatch(change('captainManageSquadChangeForm', 'childAvailableSquads', childAvailableSquads));
    dispatch(change('captainManageSquadChangeForm', 'entryId', response.entryId));
    dispatch(change('captainManageSquadChangeForm', 'isBundledChild', response.isBundledChild));
    dispatch(change('captainManageSquadChangeForm', 'parentAvailableSquads', parentAvailableSquads));
    dispatch(change('captainManageSquadChangeForm', 'parentEventName', response.parentEventName));
    dispatch(change('captainManageSquadChangeForm', 'parentSquadDateTime', formattedDate));
    dispatch(change('captainManageSquadChangeForm', 'startDate', now > response.tournamentStartDate ? now : response.tournamentStartDate));
    dispatch(change('captainManageSquadChangeForm', 'endDate', response.tournamentEndDate));

    if (parentSquadId) {
      dispatch(change('captainManageSquadChangeForm', 'parentSquadId', parentAvailableSquads.length
        ? parentAvailableSquads.find(x => x.value === parentSquadId).value
        : null));
    } else {
      dispatch(change('captainManageSquadChangeForm', 'parentSquadId', parentAvailableSquads.length
        ? parentAvailableSquads[0].value
        : null));
    }

    dispatch(arrayRemoveAll('captainManageSquadChangeForm', 'childrenEntries'));
    response.childrenEntries.forEach((value, index) => {
      if (resetChildren){
        // reset each child's squad ID to a new one - this is a MUST since the children must travel with the parent
        value.squadId = childAvailableSquads.length
          ? childAvailableSquads[0].value
          : null;
      }
      dispatch(arrayInsert('captainManageSquadChangeForm', 'childrenEntries', index, value));
    });

    resolve(response);
  })
  .catch(() => {
    toastr.error('Error getting squads!', 'There was an error getting available squad times.');
    resolve();
  });
});

export const retrieveRosterWarnings = () => (dispatch, getState) => new Promise((resolve) => {
  let state = getState().registration.shared;
  let rosterPositions = state.rosterPositions;
  let entry = state.entries.find(x => x.editing);

  // We don't verify during checkout of new entries. 
  // if (!entry) entry = state.cartEntries.find(x => x.editing);
  if (!entry) return;
  
  // create payload using form data and roster positions from state
  const payload = {
    rosterPositions
  };

  dispatch(postJsonAsync(`registration/entry/${entry.id}/verify`, payload))
    .then(response => {
      dispatch(setCaptRosterWarnings(response.virtualEntriesToModify));
      resolve();
    })
    .catch(() => resolve()); 
});

export const handleSquadChangeClick = (entryId, squadDateTime) => dispatch => new Promise(resolve => {
  dispatch(initialize('captainManageSquadChangeForm'));
  dispatch(getAvailableSquadsForDate(entryId, squadDateTime, null, true))
    .then(response => resolve(response))
    .then(() => dispatch(displaySquadChangeModal(true)));
});

export const handlePrintEntryClick = entryId => dispatch => {
  dispatch(getJsonAsync(`registration/entry/${entryId}/printable`))
    .then(payload => dispatch(handlePrint(payload)));
};

export const handlePrintPaymentLogClick = entryId => dispatch => {
  dispatch(getJsonAsync(`registration/entry/${entryId}/paymentLogPrintable`))
    .then(payload => dispatch(handlePrint(payload)));
};

export const handleAssignTeamOwnedVirtualEventClick = (virtualEventName, teamEntryId, value) => dispatch => {
  dispatch(assignTeamOwnedVirtualEntry(virtualEventName, teamEntryId, value));
};

export const handleAssignChildTeamOwnedVirtualEventClick = (virtualEventName, parentTeamEntryId, rosterPosition, value) => dispatch => {
  dispatch(assignChildTeamOwnedVirtualEntry(virtualEventName, parentTeamEntryId, rosterPosition, value));
};

export const checkForCompleteRosters = () => (dispatch, getState) => {
  const shared = getState().registration.shared;
  const entriesComplete =  shared.cartEntries.every(x => x.rosterComplete);
  const virtualEntriesComplete = shared.cartVirtualEntries.every(x => x.rosterComplete);
  const teamOwnedVirtualEntriesComplete = shared.parentVirtualEntryEvents.every(x => x.remaining === 0) && shared.childVirtualEntryEvents.every(x => x.remaining === 0);

  dispatch(setRostersComplete(entriesComplete && virtualEntriesComplete && teamOwnedVirtualEntriesComplete));
};

export const handleEventChangeClick = entryId => dispatch => {
  dispatch(initialize('captainManageEventChangeForm'));
  dispatch(retrieveAvailableEvents(entryId))
  .then(() => dispatch(displayEventChangeModal(true)));
};

const retrieveAvailableEvents = entryId => dispatch => new Promise(resolve => {
  dispatch(getJsonAsync(`registration/entry/${entryId}/availableEvents`))
  .then(response => {
      const availableEvents = response.availableEvents.map(x => ({value: x.id, label: x.description}));

      dispatch(change('captainManageEventChangeForm', 'availableEvents', availableEvents));
      dispatch(change('captainManageEventChangeForm', 'currentEventName', response.currentEventName));
      dispatch(change('captainManageEventChangeForm', 'entryId', entryId));
      resolve(response);    
  })
  .catch(() => {
    toastr.error('Error getting events!', 'There was an error getting available events.');
    resolve();
  });
});

export const handleEventChangeCancel = () => dispatch => {
  dispatch(displayEventChangeModal(false));
};

export const handleEventChangeSave = formData => (dispatch, getState) => new Promise(resolve => {
  const payload = {
    entryId: formData.entryId,
    squadId: formData.parentSquadId,
    childrenEntries: formData.childrenEntries
  };

  // Note this is the same URL used by handleSquadChangeSave
  dispatch(putJsonAsync(`registration/entry/${formData.entryId}/squad/change`, payload))
  .then(() => {
    const tournamentId = getState().registration.base.tournamentId;

    dispatch(retrieveEntries(tournamentId));
    dispatch(displayEventChangeModal(false));
    toastr.success('Event Changed!', 'The event was changed successfully.');
    resolve();
  })
  .catch(() => {
    dispatch(displayEventChangeModal(false));
    toastr.error('Event Not Updated!', 'There was an error changing event for the entry.');
    resolve();
  });
});



// WEBPACK FOOTER //
// ./src/features/registration/manage/actions.js